import {
  SELECT,
  PLAY_OR_PAUSE,
  SET_TIME,
  AUDIO_ENDED,
  SHUFFLE,
  MUTE_UNMUTE,
  ADD_TO_QUE,
  TO_ADD,
  SONG,
  PLAYLIST,
  PLAY_PLAYLIST,
  NEXT,
  PREV,
  LINEAR,
  REPEAT,
  REPEAT_1,
  VOLUME_CHANGE,
  SELECTED_TRACK,
  PLAY,
  CLEAR_QUE,
  RESET_SELECTED,
  RESET_LOADING,
  SET_LOADING,
} from "../types";
import UIkit from "uikit";
import { findNext } from "../../utils";
import { songsR } from "../types/reducers";
import { AudioActions } from "../types/audio";

export const t = {
  covername: "",
  featured: [],
  id: "",
  likes: [],
  plays: [],
  src: "",
  tag: "",
  title: "",
  uid: "",
  username: "",
  cover: "",
};

const initState: songsR = {
  tags: [],
  toAdd: t,
  que: [],
  current: t,
  audio: new Audio(),
  paused: true,
  muted: false,
  ended: false,
  mode: LINEAR,
  selected: t,
  loading: false,
  list: [],
  volume: 1.0,
};

const songsReducer = (state = initState, action: AudioActions) => {
  const { type, payload } = action;
  const { audio } = state;
  let { que, current, list, mode, muted } = state;
  var next;

  switch (type) {
    // Audio
    case SELECT:
      if (current) {
        if (!current.src || current.src !== audio.src) {
          audio.src = payload.src;
        } else {
          if (!que.includes(payload)) {
            que = [...que, payload];
          }
        }
      }

      current = payload;
      if (!que.length) {
        que = [payload];
      }

      return {
        ...state,
        current: payload,
        selected: payload,
        que,
        paused: audio.paused,
        loading: false,
      };
    case MUTE_UNMUTE:
      muted = !audio.muted;
      audio.muted = muted;
      if (audio.muted) {
        audio.volume = 0;
      } else {
        audio.volume = 1;
      }
      return {
        ...state,
        muted,
        loading: false,
        volume: audio.volume,
      };
    case VOLUME_CHANGE:
      audio.volume = Number.parseFloat(payload);
      muted = audio.volume === 0;
      audio.muted = muted;
      return {
        ...state,
        muted,
        loading: false,
        volume: audio.volume,
      };
    case PLAY:
      return {
        ...state,
        paused: audio.paused,
        current,
        loading: false,
      };
    case PLAY_OR_PAUSE:
      if (current) {
        if (current.src !== audio.src) {
          audio.src = current.src;
        }

        audio.addEventListener("loadeddata", () => {
          audio.play();
        });

        if (audio.readyState) {
          if (audio.paused && audio.src) {
            audio.play();
          } else {
            audio.pause();
          }
        }
      } else {
        UIkit.modal.dialog(
          `<p class="uk-modal-body">Select a song to play</p>`
        );
      }

      return {
        ...state,
        paused: audio.paused,
        loading: false,
      };
    case NEXT:
      if (!current) {
        UIkit.modal.dialog(
          `<p class="uk-modal-body">Select a song to play</p>`
        );
      } else {
        if (que.length > 1) {
          next = findNext(current, que, mode, true);
        } else {
          next = findNext(current, list, mode, true);
        }
        if (next) {
          if (next.src) {
            current = next;
            audio.src = current.src;

            audio.addEventListener("canplay", () => {
              audio.play();
            });
          } else {
            current = t;
            audio.pause();
          }
        }
      }

      return {
        ...state,
        current,
        paused: audio.paused,
        selected: current,
        loading: false,
      };
    case PREV:
      if (!current) {
        UIkit.modal.dialog(
          `<p class="uk-modal-body">Select a song to play</p>`
        );
      } else {
        if (que.length > 1) {
          next = findNext(current, que, mode, false);
        } else {
          next = findNext(current, list, mode, false);
        }

        if (next)
          if (next.src) {
            current = next;
            audio.src = current.src;
            audio.addEventListener("canplay", () => {
              audio.play();
            });
          } else {
            current = t;
            audio.pause();
          }
      }

      return {
        ...state,
        current,
        paused: audio.paused,
        selected: current,
        loading: false,
      };
    case SET_TIME:
      audio.currentTime = payload;
      return state;

    case AUDIO_ENDED:
      if (que.length > 1) {
        next = findNext(current, que, mode, true);
      } else {
        next = findNext(current, list, mode, true);
      }

      current = next;
      if (current) {
        audio.src = current.src;
      }
      if (!que.includes(current)) {
        que = [...que, current];
      }

      return {
        ...state,
        paused: audio.paused,
        current,
        que,
        loading: false,
      };

    // // Playlist
    // case ADD_TO_PLAYLIST:
    //   return {
    //     ...state,
    //     selected: current
    //   }
    // case DELETE_PLAYLIST:
    //   const { title } = playlists.find(pl => pl.id === payload)
    //   playlists = playlists.filter(playlist => playlist.id !== payload)
    //   UIkit.notification({
    //     message: `${title} deleted successfully`,
    //     status: `success`,
    //     timeout: 1000
    //   })
    //   return {
    //     ...state,
    //     playlists
    //   }
    case PLAY_PLAYLIST:
      if (payload.length) {
        que = payload;
        current = que[0];
        if (current) audio.src = current.src;
        audio.addEventListener("canplay", () => {
          audio.play();
        });
      } else {
        /**@todo Implement alert system */
        UIkit.modal.dialog(
          `<p class="uk-modal-body">Selected playlist has no songs</p>`
        );
        // alert("Selected playlist has no songs");
      }

      return {
        ...state,
        current,
        que,
        paused: audio.paused,
        selected: current,
        loading: false,
      };

    // Que
    case ADD_TO_QUE:
      const { modifier, content } = payload;
      if (modifier === SONG) {
        que = que.includes(content)
          ? que.filter((song) => song?.id !== content.id)
          : [...que, content];
        if (!que.includes(content)) {
          UIkit.notification({
            message: `${content.title} removed successfully`,
            status: `success`,
            timeout: 1000,
          });
        } else {
          UIkit.notification({
            message: `${content.title} added to que`,
            status: `success`,
            timeout: 1000,
          });
        }
      } else if (modifier === PLAYLIST) {
        que = [...que, ...content];
      }

      return {
        ...state,
        que,
        selected: current,
        loading: false,
      };
    case CLEAR_QUE:
      return {
        ...state,
        que: [],
      };

    //Data
    // case LOAD_DATA:
    //   return {
    //     ...state,
    //     list: payload
    //   }

    // Track

    case SELECTED_TRACK:
      return {
        ...state,
        selected: payload,
        loading: false,
      };
    case RESET_SELECTED:
      return {
        ...state,
        selected: current,
        loading: false,
      };

    // Audio modes
    case LINEAR:
    case REPEAT:
    case REPEAT_1:
    case SHUFFLE:
      return {
        ...state,
        mode: payload,
        loading: false,
      };

    // Misc
    case TO_ADD:
      return {
        ...state,
        toAdd: payload,
        loading: false,
      };
    case RESET_LOADING:
      return {
        ...state,
        loading: false,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default songsReducer;
